import { DestroyRef, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { Observable, catchError, map, of } from 'rxjs';
import { GuardPermissionService } from 'shared/services/guard-permission.service';

@Injectable()
export class CanCreateOutlet implements CanActivate {
    constructor(
        private guardPermissionService: GuardPermissionService,
        private router: Router,
        private destroyRef: DestroyRef,
    ) {}

    canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
        const listingId = route.params['id'];

        if (!listingId) {
            this.router.navigate(['dashboard']);
            return of(false);
        }

        return this.guardPermissionService.canCreateOutletObservable(listingId).pipe(
            takeUntilDestroyed(this.destroyRef),
            map((canCreate: boolean) => {
                if (!canCreate) {
                    this.router.navigate([`/listings/details/${listingId}/outlet`]);
                    return false;
                }
                return true;
            }),
            catchError(() => {
                this.router.navigate(['dashboard']);
                return of(false);
            }),
        );
    }
}
